import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import Layout from "../core/Layout";
import { listPatients, deletePatients } from "../actions/patientActions";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { Menu, Dropdown, Button } from "antd";
import { DownOutlined } from "@ant-design/icons";
import AddAppVaccineModal from "../component/modal/addAppointment";
import { usePatients } from "../component/api/patients";

const ListPatients = () => {
	const [searchDetails, setSearchDetails] = useState({
		firstName: "",
		lastName: "",
		phoneNo: "",
		patientNumber: "",
		aadharCard: "",
	});
	const [debouncedSearchDetails, setDebouncedSearchDetails] = useState({
		firstName: "",
		lastName: "",
		phoneNo: "",
		patientNumber: "",
		aadharCard: "",
	});
	const [page, setPage] = useState(1);
	const [showModal , setShowModal] = useState(false)
	const [patientId , setPatientId] = useState(null)
    const [currentPage , setCurrentPage] = useState(1)
	const dispatch =  useDispatch();
	const navigate = useNavigate();

	// Debounce search functionality
	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedSearchDetails(searchDetails);
		}, 500);

		return () => {
			clearTimeout(timer);
		};
	}, [searchDetails]);

	// Reset page when search changes
	useEffect(() => {
		setPage(1);
	}, [debouncedSearchDetails]);

	const { data, isLoading, isError } = usePatients(page, debouncedSearchDetails);

	const userLogin = useSelector((state) => state.userLogin);
	const { userInfo } = userLogin;

	useEffect(() => {
		if (!userInfo) {
			navigate("/signin");
		}
	}, [userInfo, navigate]);

	
	const deleteHandler = (id) => {
		if (window.confirm("Are you sure")) {
			dispatch(deletePatients(id));
		}
	};

	const buttonStyles = {
		background: "linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)",
		color: "white",
		borderRadius: "20px",
		padding: "8px 16px",
		fontSize: "12px",
		fontWeight: "bold",
		fontFamily: "Roboto sans-serif",
		border: "none",
		boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
		transition: "all 0.3s ease",
	};

	const componentRef = useRef();

	const menu = (patientId) => (
		<Menu style={{ 
			borderRadius: "10px", 
			boxShadow: "0 8px 24px rgba(102, 126, 234, 0.15)",
			border: "1px solid rgba(102, 126, 234, 0.1)"
		}}>
			<Menu.Item key="1" style={{ padding: "8px 16px" }}>
				<Link to={`/pat-details/${patientId}`} style={{ color: "#666a7e", textDecoration: "none" }}>
					More Details
				</Link>
			</Menu.Item>
			<Menu.Item key="2" onClick = {() => {
				setShowModal(true) 
				setPatientId(patientId)}
			} style={{ padding: "8px 16px" }}>
				<span style={{ color: "#666a7e" }}>Add Appointment</span>
			</Menu.Item>
			<Menu.Item key="3" style={{ padding: "8px 16px" }}>
				<Link to={`/update-patient/${patientId}`} style={{ color: "#666a7e", textDecoration: "none" }}>
					Update Patient
				</Link>
			</Menu.Item>
			<Menu.Item key="4" onClick={() => deleteHandler(patientId)} style={{ padding: "8px 16px" }}>
				<span style={{ color: "#e74c3c" }}>Delete Patient</span>
			</Menu.Item>
		</Menu>
	);

	const cardStyles = {
		background: "white",
		borderRadius: "15px",
		boxShadow: "0 10px 30px rgba(102, 126, 234, 0.1)",
		border: "1px solid rgba(102, 126, 234, 0.1)",
		overflow: "hidden",
		marginBottom: "20px"
	};

	const headerStyles = {
		background: "linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)",
		color: "white",
		borderRadius: "15px 15px 0px 0px",
		padding: "20px 25px",
		borderBottom: "none",
		marginBottom: "0"
	};

	const inputStyles = {
		borderRadius: "10px",
		border: "2px solid rgba(102, 126, 234, 0.2)",
		padding: "10px 14px",
		fontSize: "14px",
		transition: "all 0.3s ease",
		outline: "none",
		boxShadow: "0 2px 8px rgba(102, 126, 234, 0.1)",
		width: "100%",
		minHeight: "42px"
	};

	const tableHeaderStyles = {
		background: "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
		color: "#666a7e",
		fontWeight: "600",
		padding: "15px",
		borderBottom: "2px solid rgba(102, 126, 234, 0.2)"
	};

	const tableCellStyles = {
		padding: "12px 15px",
		borderBottom: "1px solid rgba(102, 126, 234, 0.1)",
		color: "#000000"
	};

	const patientNameStyles = {
		padding: "12px 15px",
		borderBottom: "1px solid rgba(102, 126, 234, 0.1)",
		color: "#0000FF"
	};

	const actionButtonStyles = {
		background: "linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)",
		color: "white",
		border: "none",
		borderRadius: "8px",
		padding: "6px 12px",
		fontSize: "12px",
		fontWeight: "500",
		boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
		transition: "all 0.3s ease"
	};

	const paginationStyles = {
		marginBottom: "20px",
		display: "flex",
		gap: "20px",
		justifyContent: "right",
		width: "100%",
		alignItems: "center"
	};

	const paginationButtonStyles = {
		background: "linear-gradient(135deg, rgb(102, 126, 234) 0%, rgb(118, 75, 162) 100%)",
		color: "white",
		border: "none",
		borderRadius: "8px",
		padding: "8px 12px",
		fontSize: "14px",
		fontWeight: "500",
		cursor: "pointer",
		transition: "all 0.3s ease",
		boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)"
	};

	const disabledButtonStyles = {
		background: "rgba(102, 126, 234, 0.3)",
		color: "rgba(255, 255, 255, 0.6)",
		cursor: "not-allowed"
	};

	return (
		<>
		{ showModal &&  (
		<AddAppVaccineModal
                show={showModal}
                onClose={() => setShowModal(false)}
                patientId={patientId}
            />)}
		<Layout title="" className="container-fluid">
			<div style={cardStyles}>
				<div style={headerStyles}>
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
						<h2 style={{ margin: "0", fontSize: "24px", fontWeight: "600" }}>List Patients</h2>
						<Link to="/add-patient-details">
							<Button type="primary" style={buttonStyles}>
								+ Add Patient Details
							</Button>
						</Link>
					</div>
				</div>
				
				<div style={{ padding: "25px" }}>
					{isError && (
						<div
							className="alert alert-danger"
							style={{ 
								display: isError ? "" : "none",
								backgroundColor: "#fee2e2",
								border: "1px solid #fecaca",
								borderRadius: "10px",
								padding: "12px 16px",
								color: "#dc2626",
								marginBottom: "20px"
							}}>
							{isError}
						</div>
					)}
					
					{isLoading && (
						<div className="d-flex justify-content-center" style={{ padding: "40px" }}>
							<div className="spinner-border" role="status" style={{ color: "#666a7e" }}>
								
							</div>
						</div>
					)}
					
					{/* Search Filters - All */}
					<div className="row mb-4">
						<div className="col-md-2 col-sm-6 col-12 mb-3">
							<input
								type="text"
								className="form-control"
								placeholder="First Name"
								value={searchDetails.firstName}
								onChange={(e) =>
									setSearchDetails({
										...searchDetails,
										firstName: e.target.value.trim(),
									})
								}
								style={inputStyles}
								onFocus={(e) => e.target.style.borderColor = "rgb(102, 126, 234)"}
								onBlur={(e) => e.target.style.borderColor = "rgba(102, 126, 234, 0.2)"}
							/>
						</div>
						<div className="col-md-2 col-sm-6 col-12 mb-3">
							<input
								type="text"
								className="form-control"
								placeholder="Last Name"
								value={searchDetails.lastName}
								onChange={(e) =>
									setSearchDetails({
										...searchDetails,
										lastName: e.target.value.trim(),
									})
								}
								style={inputStyles}
								onFocus={(e) => e.target.style.borderColor = "rgb(102, 126, 234)"}
								onBlur={(e) => e.target.style.borderColor = "rgba(102, 126, 234, 0.2)"}
							/>
						</div>
						<div className="col-md-2 col-sm-6 col-12 mb-3">
							<input
								type="number"
								className="form-control"
								placeholder="Phone No"
								value={searchDetails.phoneNo}
								onChange={(e) =>
									setSearchDetails({
										...searchDetails,
										phoneNo: e.target.value.trim(),
									})
								}
								style={inputStyles}
								onFocus={(e) => e.target.style.borderColor = "rgb(102, 126, 234)"}
								onBlur={(e) => e.target.style.borderColor = "rgba(102, 126, 234, 0.2)"}
							/>
						</div>
						<div className="col-md-2 col-sm-6 col-12 mb-3">
							<input
								type="text"
								className="form-control"
								placeholder="Patient Number"
								value={searchDetails.patientNumber}
								onChange={(e) =>
									setSearchDetails({
										...searchDetails,
										patientNumber: e.target.value.trim(),
									})
								}
								style={inputStyles}
								onFocus={(e) => e.target.style.borderColor = "rgb(102, 126, 234)"}
								onBlur={(e) => e.target.style.borderColor = "rgba(102, 126, 234, 0.2)"}
							/>
						</div>
						<div className="col-md-2 col-sm-6 col-12 mb-3">
							<input
								type="number"
								className="form-control"
								placeholder="Aadhar Card"
								value={searchDetails.aadharCard}
								onChange={(e) =>
									setSearchDetails({
										...searchDetails,
										aadharCard: e.target.value.trim(),
									})
								}
								style={inputStyles}
								onFocus={(e) => e.target.style.borderColor = "rgb(102, 126, 234)"}
								onBlur={(e) => e.target.style.borderColor = "rgba(102, 126, 234, 0.2)"}
							/>
						</div>
					</div>
					
					{/* Table */}
					<div className="row" ref={componentRef}>
						<div className="table-responsive">
							<table className="table" style={{ borderRadius: "10px", overflow: "hidden", boxShadow: "0 4px 12px rgba(102, 126, 234, 0.1)" }}>
								<thead>
									<tr className="text-center">
										<th style={tableHeaderStyles}>Patient Number</th>
										<th style={tableHeaderStyles}>Patient</th>
										<th style={tableHeaderStyles}>Phone No</th>
										<th style={tableHeaderStyles}>Reg Date</th>
										<th style={tableHeaderStyles}>Gender</th>
										<th style={tableHeaderStyles}>Actions</th>
									</tr>
								</thead>
								<tbody>
								{data?.patient  ? data?.patient.map((p, i) => (
									<tr key={p._id} className="text-center" style={{ transition: "all 0.3s ease" }}
										onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(102, 126, 234, 0.25)"}
										onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}>
										<td style={tableCellStyles}>{p.patientNumber}</td>
										<td style={patientNameStyles}>
											<Link to={`/pat-details/${p?._id}`} style={{ 
												color: "#0000FF", 
												textDecoration: "none",
												fontWeight: "500"
											}}>
												{p.firstName + ' ' + p.lastName}
											</Link>
										</td>
										<td style={tableCellStyles}>{p.phoneNo}</td>
										<td style={tableCellStyles}>{dayjs(p.regDate).format('YYYY-MM-DD HH:mm Z')}</td>
										<td style={tableCellStyles}>{p.gender}</td>
										<td style={tableCellStyles}>
											<Dropdown overlay={menu(p._id)} trigger={['click']}>
												<Button style={actionButtonStyles}>
													Actions <DownOutlined />
												</Button>
											</Dropdown>
										</td>
									</tr>
								)) :  (
									<tr>
										<td colSpan={6} className="text-center" style={{ 
											...tableCellStyles, 
											padding: "40px",
											color: "#666a7e",
											fontStyle: "italic"
										}}>
											No patient in the list
										</td>
									</tr>
								)}
								</tbody>
							</table>
						</div>
					</div>
					
					{/* Pagination */}
					<div style={paginationStyles}>
						<button 
							style={{
								...paginationButtonStyles,
								...(page === 1 ? disabledButtonStyles : {})
							}}
							disabled={page === 1} 
							onClick={() => setPage(p => p - 1)}
						>
							{"<"}
						</button>
						<span style={{ 
							color: "#666a7e", 
							fontWeight: "500",
							fontSize: "14px"
						}}>
							Page {data?.currentPage} of {data?.totalPages}
						</span>
						<button  
							style={{
								...paginationButtonStyles,
								...(page === data?.totalPages ? disabledButtonStyles : {})
							}}
							disabled={page === data?.totalPages} 
							onClick={() => setPage(p => p + 1)}
						>
							{">"}
						</button>
					</div>
				</div>
			</div>
		</Layout>
		</>
	);
};

export default ListPatients;